import { sum, avg } from '../shared/math'

export const calculateStockAggregate = ({ data, monthKeys, sumFields = [], avgFields = [] }) => {
  return monthKeys.map(key => {
    const [year, month] = key.split('-');
    const entries = data.filter(
      d => d.year === Number(year) && d.month === Number(month)
    );

    const result = {};

    sumFields.forEach(({ field, format }) => {
      const value = sum(field, entries);
      result[`_${field}`] = value;
      result[field] = value != null ? format(value) : null;
    });

    avgFields.forEach(({ field, format }) => {
      const value = avg(field, entries);
      result[field] = value != null ? format(value) : null;
    });

    return result;
  });
};